import { render, staticRenderFns } from "./leaveForm.vue?vue&type=template&id=98b18a82&scoped=true&"
import script from "./leaveForm.vue?vue&type=script&lang=js&"
export * from "./leaveForm.vue?vue&type=script&lang=js&"
import style0 from "./leaveForm.vue?vue&type=style&index=0&id=98b18a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b18a82",
  null
  
)

export default component.exports